<!--
Доработать компоненты
-->
<ng-container *ngIf="modalService.modals.$ | async as modals">
    <bazis-modal
        *ngFor="let modal of modals"
        [modal]="modal"
    ></bazis-modal>
</ng-container>
